import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataUser } from '../types/masterdata-entities';
import { ACTIVE_ONLY, keyName } from './shared';

export const MASTERDATA_USER = defineMasterdataEntity<MasterdataUser>({
  name: 'user',
  responseKey: 'users',
  displayWith: (u) => {
    const person = [u.lastName, u.firstName].filter(Boolean).join(' ');
    return keyName(u.key, person || null);
  },
  secondaryWith: (u) => u.shortCode,
  defaultFilter: ACTIVE_ONLY,
  icon: 'fa-regular fa-user',
  title: 'Anwendersuche',
  label: 'Anwender',
  placeholder: 'Anwender suchen...',
  columns: [
    {
      label: 'Anwender',
      type: 'entity',
      icon: 'fa-regular fa-user',
      value: (u) => {
        const person = [u.lastName, u.firstName].filter(Boolean).join(' ');
        return keyName(u.key, person || null);
      },
      secondary: (u) => u.shortCode,
    },
    { label: 'Schlüssel', type: 'text', value: (u) => u.key },
    { label: 'Nachname', type: 'text', value: (u) => u.lastName },
    { label: 'Vorname', type: 'text', value: (u) => u.firstName },
    { label: 'Namenszusatz', type: 'text', value: (u) => u.nameSuffix },
    { label: 'Kürzel', type: 'text', value: (u) => u.shortCode },
    { label: 'Durchwahl', type: 'text', value: (u) => u.extension },
    { label: 'Telefon (Büro)', type: 'text', value: (u) => u.officePhone },
    { label: 'Aktiv', type: 'text', value: (u) => (u.active ? 'Ja' : 'Nein') },
  ],
});
